// extracted by mini-css-extract-plugin
module.exports = {"col":"CheckboxItems_col__oOWrk","row":"CheckboxItems_row__2Skdb","modal-row":"CheckboxItems_modal-row__15jZG"};